<template>
  <v-content>
    <v-portal-tool-bar/>
    <v-container
    class='main--text'
      fluid>
      <v-row
        justify=center>
        <v-col
          cols=12
          sm=10
          md=8>
          <v-card>
            <v-container
              fluid>
              <h3>お問い合わせフォーム</h3>
            </v-container>
            <v-contact-form
              v-model="inputValue"
              :categories="categories"
              @submit-button-click="submit"/>
          </v-card>
        </v-col>
      </v-row>
      <v-row
        justify=center>
        <v-col
          sm=10
          md=8>
          <v-btn
            outlined
            depressed
            rounded
            @click="$router.push({path: '/'})">
            トップへ
          </v-btn>
        </v-col>
      </v-row>
      <v-dialog
        :value="succeeded"
        width=400>
        <v-card>
          <v-container
            fluid>
            <v-row>
              <v-col>
                送信が完了しました。<br>
                回答はメールにてお送りします。<br>
                頂いているお問い合わせの多寡により、<br>
                最大一週間程度いただく可能性もございます。<br>
                予め、ご了承ください。
              </v-col>
            </v-row>
            <v-row
              justify=center>
              <v-col
                cols=auto>
                <v-btn
                  outlined
                  depressed
                  color=primary
                  @click="closeSuccessDialog">
                  閉じる
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <v-dialog
        :value="failed"
        width=400>
        <v-container
          fluid>
          <v-row>
            <v-col>
              サーバーにエラーが発生しました。<br>
              しばらくの後、再度ご利用ください。
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols=auto>
                <v-btn
                  outlined
                  depressed
                  color=primary
                  @click="closeFailureDialog">
                  閉じる
                </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-dialog>
    </v-container>
    <v-portal-footer/>
  </v-content>
</template>


<script>
import VPortalToolBar from '@/components/organisms/portal/VPortalToolBar'
import VContactForm from '@/components/organisms/portal/VContactForm.vue'
import VPortalFooter from '@/components/organisms/portal/VPortalFooter.vue'
import { InquiryCategory } from '@/models/Inquiry'
import { InquiryRepository } from "@/repository/InquiryRepository"
import { firestore } from "@/repository/client/firestore"

export default {
  components: {
    VPortalToolBar,
    VContactForm,
    VPortalFooter
  },
  data () {
    return {
      categories: InquiryCategory,
      inputValue: {},
      succeeded: false,
      failed: false
    }
  },
  methods: {
    async submit () {
      try {
        const result = await this.inquiryRepo.put(
          (this.inputValue.inquirer) ? this.inputValue.inquirer : this.inputValue.email,
          this.inputValue.email,
          this.inputValue.category,
          this.inputValue.content
        )
        this.succeeded = true
      } catch (e) {
        this.failed = true
      }
    },
    closeSuccessDialog() {
      this.inputValue = {
        email: "",
        category: "",
        content: ""
      }
      this.succeeded = false
    },
    closeFailureDialog() {
      this.failed = false
    }
  },
  created () {
    this.inquiryRepo = new InquiryRepository(firestore)
  }

}
</script>
